import { render, staticRenderFns } from "./VeryHighTaxe.vue?vue&type=template&id=03db67f3&"
import script from "./VeryHighTaxe.vue?vue&type=script&lang=js&"
export * from "./VeryHighTaxe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports